import { render, staticRenderFns } from "./ValueAdded.vue?vue&type=template&id=41864a30&scoped=true&"
import script from "./ValueAdded.vue?vue&type=script&lang=js&"
export * from "./ValueAdded.vue?vue&type=script&lang=js&"
import style0 from "./ValueAdded.vue?vue&type=style&index=0&id=41864a30&scoped=true&lang=css&"
import style1 from "./ValueAdded.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41864a30",
  null
  
)

export default component.exports